import { MdOutlineDescription } from "react-icons/md";
import DownloadPDFWithFetch from "../DownloadPDF/DownloadPDFWithFetch";

interface DownloadCardProps {
    title: string;
    fileName: string;
    module: string;
}

const DownloadCard = ({ title, fileName, module }: DownloadCardProps) => {
    return (
        <div className="bg-[#D8DCE6]/20 rounded-sm mt-12 border border-system-light-20">
            <div className="px-4 py-4 flex justify-between items-center">
                <div className="flex gap-4 items-center">
                    <div className="w-[1.5rem] h-[1.5rem]">
                        <MdOutlineDescription size={24} className="text-primary-10" />
                    </div>
                    <p className="text-primary-10 text-bmedium">{title}</p>
                </div>
                <DownloadPDFWithFetch
                    fileName={fileName}
                    module={module}
                    source={module}
                    label=""
                    iconSize={24}
                    variant="ghost"
                    className="text-brand-green-30"
                />
            </div>
        </div>
    )
}

export default DownloadCard